import { LinearProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import React from "react";

export default function Progress(props) {
  const item = props.item;
  const iconYn = props.iconYn;

  const useStyles = makeStyles((theme, props) => ({
    progress: {
      position: "relative",
      width: iconYn == "Y" ? "calc(100% - 54px)" : "",
      margin: "0 auto",
      "& .MuiLinearProgress-root": {
        height: rem(10),
        borderRadius: rem(10),
        margin: `${rem(41)} 0`,
        background: `repeating-linear-gradient(90deg, ${item.clr}66, ${
          item.clr
        }66 1px, ${item.clr}26 0, ${item.clr}26 25%)`,

        "& .MuiLinearProgress-bar": {
          backgroundColor: `${item.clr}`,
          borderRadius: rem(10),
        },
      },
      "& .icon": {
        position: "absolute",
        top: "50%",
        right: 0,
        // transform: "translate(-31px,-50%)",
        transform: "translate(-27px,-50%)",
        width: rem(54),
        height: rem(54),
        backgroundRepeat: "no-repeat",
        left: `${(item.accCount / item.totalMaxCount) * 100}%`,
        backgroundImage: `${"url(" + item.actvImgUrl + ")"}`,
        borderRadius: "50%",
        backgroundSize: "100% 100%",
      },
    },
  }));

  const classes = useStyles();

  return (
    <>
      <div className={classes.progress}>
        <LinearProgress
          variant="determinate"
          value={(item.accCount / item.totalMaxCount) * 100}
        />
        {iconYn == "Y" && <div className="icon" />}
      </div>
    </>
  );
}
